var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 2.7207C9.4668 2.7207 3.4668 8.70737 3.4668 16.0807C3.4668 22.7474 8.3468 28.2807 14.7201 29.2807V19.9474H11.3335V16.0807H14.7201V13.134C14.7201 9.78737 16.7068 7.94737 19.7601 7.94737C21.2135 7.94737 22.7335 8.2007 22.7335 8.2007V11.494H21.0535C19.4001 11.494 18.8801 12.5207 18.8801 13.574V16.0807H22.5868L21.9868 19.9474H18.8801V29.2807C22.0221 28.7845 24.8831 27.1814 26.9467 24.7608C29.0103 22.3402 30.1406 19.2616 30.1335 16.0807C30.1335 8.70737 24.1335 2.7207 16.8001 2.7207Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;